/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StorageObjectDto } from '../../models/storage-object-dto';
import { UpdateStorageObjectRequest } from '../../models/update-storage-object-request';

export interface UpdateStorageObject$Params {
  id: string;
      body: UpdateStorageObjectRequest
}

export function updateStorageObject(http: HttpClient, rootUrl: string, params: UpdateStorageObject$Params, context?: HttpContext): Observable<StrictHttpResponse<StorageObjectDto>> {
  const rb = new RequestBuilder(rootUrl, updateStorageObject.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StorageObjectDto>;
    })
  );
}

updateStorageObject.PATH = '/v0/storageObjects/{id}';
